import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Add as AddIcon } from "@mui/icons-material";
import { useStation } from "../providers/StationProvider";
import { useResponsivePage } from "../components/common/core/ResponsivePage";


export default function useAddMissionFab(active = true) {
  const { createMissionDraft } = useStation();
  const { setActionButton } = useResponsivePage();
  const { t } = useTranslation();

  useEffect(() => {
    if (active) {

      setActionButton({
        text: t("dispatch:createMission"),
        icon: <AddIcon />,
        onClick: createMissionDraft,
        color: "primary"
      });

      return () => {
        setActionButton(null);
      };
    }
  }, [createMissionDraft, setActionButton, t, active]);
}

export function AddMissionFab() {
  useAddMissionFab();
  return (null);
}